import React from "react";
import ReactDOM from "react-dom/client";
// import './index.css';
import App from "./App";
import "./assests/css/templatemo-lava.css";
import "./assests/css/font-awesome.css";
import "./assests/css/flex-slider.css";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
      token: {
        colorPrimary: '#5A8CB1',
      },
    }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
